export default [{
  path: 'vehicleAttendance',
  name: 'vehicleAttendance',
  component: function component() {
    return import('@/views/tms/reportManage/vehicleAttendance');
  }
}, {
  path: 'weighbridgeWeighList',
  name: 'weighbridgeWeighList',
  component: function component() {
    return import('@/views/tms/reportManage/weighbridgeWeighList');
  }
}, {
  path: 'weighbridgeCarryList',
  name: 'weighbridgeCarryList',
  component: function component() {
    return import('@/views/tms/reportManage/weighbridgeCarryList');
  }
}, {
  path: 'weighbridgeSummaryList',
  name: 'weighbridgeSummaryList',
  component: function component() {
    return import('@/views/tms/reportManage/weighbridgeSummaryList');
  }
}, {
  path: 'vehicleTransportList',
  name: 'vehicleTransportList',
  component: function component() {
    return import('@/views/tms/transport/list');
  }
}, {
  path: 'vehicleTransportDetailList',
  name: 'vehicleTransportDetailList',
  component: function component() {
    return import('@/views/tms/transport/detailList');
  }
}];